import React from "react";
import {Link, useMatch, useResolvedPath} from "react-router-dom";
import {LoggedInRoutes} from "../../../LoggedInRoutes";
import ClusterHealthStatus from "./ui/ClusterHealthStatus";

function SidebarLink({to, children}) {
  const resolved = useResolvedPath(to);
  const match = useMatch({path: resolved.pathname, end: true});

  return (
      <li className={match ? "active" : ""}>
        <Link to={to}>{children}</Link>
      </li>
  )
}

export default function ClusterDetailsSidebar(props) {

  const cluster = props.cluster;
  const clusterId = props.clusterId;

  return (
      <React.Fragment>
        <ul>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.SHOW(clusterId)}>
            <i className="bx bx-home sidebar-icon" /> Overview
          </SidebarLink>
        </ul>

        <ul>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.NODES(clusterId)}>
            <i className="bx bx-hive sidebar-icon"/> Nodes
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.TAPS(clusterId)}>
            <i className="bx bx-server sidebar-icon"/> Taps
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.HEALTH(clusterId)}>
            <i className="bx bx-heart sidebar-icon"/> Health {cluster && <ClusterHealthStatus cluster={cluster}/>}
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.SUPPORT(clusterId)}>
            <i className="bx bx-support sidebar-icon"/> Support
          </SidebarLink>
        </ul>

        <ul>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.DATA.GEOIP(clusterId)}>
            <i className="bx bx-globe sidebar-icon" /> GeoIP
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.DATA.OUIS(clusterId)}>
            <i className="bx bx-data sidebar-icon" /> OUIs
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.DATA.BLUETOOTH(clusterId)}>
            <i className="bx bx-bluetooth sidebar-icon" /> Bluetooth
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.DATA.UAV(clusterId)}>
            <i className="bx bxs-paper-plane sidebar-icon" /> UAV
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.DATA.ENVIRONMENT(clusterId)}>
            <i className="bx bxs-cloud-lightning sidebar-icon" /> Environment
          </SidebarLink>
        </ul>

        <ul>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.APIKEY(clusterId)}>
            <i className="bx bx-key sidebar-icon" /> API Key
          </SidebarLink>
          <SidebarLink to={LoggedInRoutes.CLUSTERS.SETTINGS.INDEX(clusterId)}>
            <i className="bx bx-cog sidebar-icon" /> Settings
          </SidebarLink>
        </ul>
      </React.Fragment>
  )

}
